import React from 'react'
import { CButton } from '@coreui/react-pro'
import { ConfiaCarTooltip } from '../../Tolltip'

const ConfiaCarButtonHint = (props) => {
  const { children, content } = props
  return (
    <ConfiaCarTooltip content={content}>
      <CButton size={'sm'} {...props}>
        {children}
      </CButton>
    </ConfiaCarTooltip>
  )
}

export { ConfiaCarButtonHint }
